import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6529bd32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "counter" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "subtitle"
}

import { MinusIcon, PlusIcon } from '@heroicons/vue/24/solid';
import { ref, watch } from 'vue';
import { pluralize } from '@/lib/claimUtil';

interface NumberToMintInputProps {
  numberToMint: number;
  maxNumberToMint: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberToMintInput',
  props: {
    numberToMint: null,
    maxNumberToMint: null
  },
  emits: ['numberToMintChanged'],
  setup(__props: any, { emit }) {

const props = __props as {
  numberToMint: number;
  maxNumberToMint: number;
};



const _numberToMint = ref(props.numberToMint);

const allowOnlyNumbers = (event: any) => {
  const value = event.target.value;
  const newValue = value.replace(/[^0-9]/g, '').replace(/^0+/, '');

  if (newValue === '') {
    _numberToMint.value = 0;
    event.target.value = 0;
    return;
  }

  _numberToMint.value = parseInt(newValue);
  event.target.value = newValue;
};

const decreaseMintAmount = () => {
  if (_numberToMint.value > 1) {
    _numberToMint.value -= 1;
  }
};

const increaseMintAmount = () => {
  if (_numberToMint.value < props.maxNumberToMint || props.maxNumberToMint === 0) {
    _numberToMint.value += 1;
  }
};

const plusTen = () => {
  _numberToMint.value += 10;
};

const setMintToMax = () => {
  _numberToMint.value = props.maxNumberToMint;
};



watch(_numberToMint, (value) => {
  emit('numberToMintChanged', value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "circle-button",
          type: "button",
          disabled: _numberToMint.value <= 1,
          onClick: decreaseMintAmount
        }, [
          _createVNode(_unref(MinusIcon))
        ], 8, _hoisted_3),
        _withDirectives(_createElementVNode("input", {
          class: "number-input",
          inputmode: "numeric",
          onInput: allowOnlyNumbers,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_numberToMint).value = $event))
        }, null, 544), [
          [_vModelText, _numberToMint.value]
        ]),
        _createElementVNode("button", {
          class: "circle-button",
          type: "button",
          disabled: _numberToMint.value >= __props.maxNumberToMint && __props.maxNumberToMint !== 0,
          onClick: increaseMintAmount
        }, [
          _createVNode(_unref(PlusIcon))
        ], 8, _hoisted_4),
        (__props.maxNumberToMint === 0 || __props.maxNumberToMint > 100)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "absolute-side circle-button circle-button-small large-font",
              type: "button",
              onClick: plusTen
            }, " +10 "))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "absolute-side circle-button circle-button-small",
              type: "button",
              disabled: __props.maxNumberToMint <= 0,
              onClick: setMintToMax
            }, " Max ", 8, _hoisted_5))
      ])
    ]),
    (__props.maxNumberToMint > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", null, "You can claim at most " + _toDisplayString(`${__props.maxNumberToMint} ${_unref(pluralize)(__props.maxNumberToMint, 'item')}`), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})